import { create } from "zustand"

export interface OrderDraftConflict {
  latestRevision: number
  artifactBlobUrl: string
}

interface OrderDraftState {
  content: string
  isSaved: boolean
  baseRevision: number
  conflict: OrderDraftConflict | null

  setContent: (content: string) => void
  appendDelta: (delta: string) => void
  setSaved: (saved: boolean) => void
  setBaseRevision: (revision: number) => void
  setConflict: (conflict: OrderDraftConflict | null) => void
  reset: () => void
}

const initialState = {
  content: "",
  isSaved: true,
  baseRevision: 0,
  conflict: null,
}

export const useOrderDraftStore = create<OrderDraftState>((set) => ({
  ...initialState,

  // Bail when the content is unchanged. Three independent load-time sources
  // (GCS blob, agent checkpoint, rewrite snapshot) call setContent with the
  // same string during the open; without this bail each call minted a new
  // state object (isSaved:false) and re-rendered every subscriber, defeating
  // all downstream memoization — the Analysis-tab freeze. A no-op write must
  // be a no-op.
  setContent: (content) =>
    set((prev) => (prev.content === content ? prev : { content, isSaved: false })),

  appendDelta: (delta) =>
    set((prev) => ({ content: prev.content + delta, isSaved: false })),

  setSaved: (isSaved) => set({ isSaved }),

  setBaseRevision: (baseRevision) => set({ baseRevision }),

  setConflict: (conflict) => set({ conflict }),

  reset: () => set(initialState),
}))
